import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useLang } from "@/i18n";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import ReleasesPage from "@/pages/ReleasesPage";
import ReleaseWizardPage from "@/pages/ReleaseWizardPage";
import ReleaseDetailPage from "@/pages/ReleaseDetailPage";
import ProfilesPage from "@/pages/ProfilesPage";
import SmartlinksPage from "@/pages/SmartlinksPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import PaymentsPage from "@/pages/PaymentsPage";
import ImportPage from "@/pages/ImportPage";
import CalendarPage from "@/pages/CalendarPage";
import BotPage from "@/pages/BotPage";
import TeamPage from "@/pages/TeamPage";
import SettingsPage from "@/pages/SettingsPage";

const Protected = ({ roles, children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-muted-foreground text-sm">Cargando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

function App() {
  const [lang] = useLang();
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes key={lang}>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/registro" element={<RegisterPage />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/lanzamientos" element={<ReleasesPage />} />
              <Route path="/lanzamientos/nuevo" element={<ReleaseWizardPage />} />
              <Route path="/lanzamientos/:id" element={<ReleaseDetailPage />} />
              <Route path="/lanzamientos/:id/editar" element={<ReleaseWizardPage />} />
              <Route path="/artistas" element={<ProfilesPage />} />
              <Route path="/smartlinks" element={<SmartlinksPage />} />
              <Route path="/analiticas" element={<AnalyticsPage />} />
              <Route path="/pagos" element={<PaymentsPage />} />
              <Route path="/importar" element={<ImportPage />} />
              <Route path="/calendario" element={<CalendarPage />} />
              <Route path="/bot" element={<Protected roles={["admin", "manager"]}><BotPage /></Protected>} />
              <Route path="/bot/:jobId" element={<Protected roles={["admin", "manager"]}><BotPage /></Protected>} />
              <Route path="/equipo" element={<Protected roles={["admin", "manager"]}><TeamPage /></Protected>} />
              <Route path="/ajustes" element={<Protected roles={["admin", "manager"]}><SettingsPage /></Protected>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
